import {useSearchOptions} from "../../../hooks/useSearchOptions";
import {inventoryListURL} from "./inventoryTable.constants";

export const useInventorySearchOptions = () => {
  const options = useSearchOptions(inventoryListURL, [
    "mac",
    "systemproperties__serial",
    "check_code",
    "claimed_by__name",
  ]);

  const searchOptions = [
    {
      category: {label: "MAC", value: "mac"},
      operator: ["=", "contains"],
      isAllowCustomValue: true,
      options: options.mac,
    },
    {
      category: {label: "Serial", value: "systemproperties__serial"},
      operator: ["=", "contains"],
      isAllowCustomValue: true,
      options: options.systemproperties__serial,
    },
    {
      category: {label: "Check Code", value: "check_code"},
      operator: ["=", "contains"],
      isAllowCustomValue: true,
      options: options.check_code,
    },
    {
      category: {label: "Is Claimed", value: "is_claimed"},
      operator: ["="],
      options: [
        {label: "true", value: true},
        {label: "false", value: false},
      ],
    },
    {
      category: {label: "Claimed By", value: "claimed_by__name"},
      operator: ["contains"],
      isAllowCustomValue: true,
      options: options.claimed_by__name,
    },
  ];

  return {searchOptions};
};
